module.exports = __webpack_public_path__ + "img/aParty_091123_C.63a9c30f.jpg";